import { HandoffSession } from '../models/handoffSession';
import { getHandoffSession as getHandoffSessionImport } from '../lib-api/services/HandoffSession';

type PollHandoffSessionPayload = {
  handoffSessionId: string;
  shouldStopPoller: (handoffSession: HandoffSession) => boolean;
  handlePollerError: () => void;
  getHandoffSession?: typeof getHandoffSessionImport;
};

export const pollHandoffSession = ({
  handoffSessionId,
  shouldStopPoller,
  handlePollerError,
  getHandoffSession = getHandoffSessionImport,
}: PollHandoffSessionPayload) => {
  let stopPoller = false;

  const interval = setInterval(async () => {
    if (stopPoller) {
      return;
    }

    const response = await getHandoffSession({ handoffSessionId });

    if (!response.isOk()) {
      handlePollerError();
    }

    if (response.data && shouldStopPoller(response.data)) {
      stopPoller = true;
    }
  }, 1000);

  return () => {
    clearInterval(interval);
    stopPoller = true;
  };
};
